import { Box, Typography } from '@mui/material';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import styled, { css } from 'styled-components';

const StyledBox = styled(Box)`
display: flex;
align-items: center;
`

const StyledPriceDetailItem = styled(Box) <{ $isTotal: boolean; $hasUnderline: boolean; $isIndented: boolean; $isDiscount: boolean }>`
  display: flex;
  justify-content: space-between;

  &:not(:first-child) {
    margin-top: ${props => props.theme.spacing(1)};
  }

  ${props =>
    props.$isDiscount &&
    css`
      color: green;
    `}

  & p {
    ${props =>
    props.$isTotal &&
    css`
        text-decoration: none !important;
        font-weight: 700;
      `}

    &:first-child {
          ${props =>
    props.$hasUnderline &&
    css`
       text-decoration: underline;
      cursor: pointer;
      `}
     

      ${props =>
    props.$isIndented &&
    css`
          margin-left: ${props => props.theme.spacing(1.5)};
        `}
    }
  }
`;

interface PriceDetailItemProps {
  label: string;
  value: string;
  LeftComponent?: JSX.Element;
  isDiscount?: boolean;
  isIndented?: boolean;
  isTotal?: boolean;
  hasUnderline?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
}

export const CheckoutSummaryPriceDetailItem = ({
  label,
  value,
  LeftComponent,
  isIndented = false,
  isTotal = false,
  isDiscount = false,
  hasUnderline = true,
  isLoading = false,
  onClick = () => null,
}: PriceDetailItemProps) => {
  return (
    <StyledPriceDetailItem $isIndented={isIndented} $isTotal={isTotal} $hasUnderline={hasUnderline} $isDiscount={isDiscount}>
      {isLoading ? (
        <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
          <Typography>{label}</Typography>
        </LoadingSkeleton>
      ) : (
        <>
          <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
            <StyledBox>{LeftComponent} <Typography onClick={onClick}>{label}</Typography></StyledBox>
          </LoadingSkeleton>
          <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
            <Typography>{value}</Typography>
          </LoadingSkeleton>
        </>
      )}
    </StyledPriceDetailItem>
  );
};
